import styled from "styled-components";

import Button from "../Button";

export const SectionRetry = styled(Button)`
  align-self: center;
`;
